import CloseIcon from '@mui/icons-material/Close';
import { IconButton, TextField } from '@mui/material';
import { styled } from '@mui/system';

export const DialogContentWrapper = styled('div')({
  padding: '20px',
  width: '605px',
  color: 'black'
});

export const CloseDialogButton = styled((props: any) => (
  <IconButton aria-label="close" sx={{ position: 'absolute', right: 8, top: 8 }} {...props}>
    <CloseIcon />
  </IconButton>
))(() => ({}));

export const DialogSubtitle = styled('div')({
  fontSize: '15px',
  cursor: 'default',
  padding: '10px 0'
});

export const NoteText = styled((props: any) => <TextField sx={{ width: '100%', margin: '0 0 30px 0' }} {...props} />)(
  () => ({})
);
